import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import ModalVideo from 'react-modal-video';
import './HomeAbout.css';

export default function HomeAbout() {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => setIsOpen(!isOpen);

  return (
    <section
      id="about"
      className="about-us-area pt-155 pb-30 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30"
    >
      <div className="container">
        <div className="row">
          {/* -------- Stats -------- */}
          <div className="col-lg-5">
            <div className="stats-wrapper mb-30">
              <div className="stats-grid">
                <div className="stat-item">
                  <h3 className="stat-number">10M+</h3>
                  <p className="stat-label">CRM Messages Delivered</p>
                </div>
                <div className="stat-item">
                  <h3 className="stat-number">1K+</h3>
                  <p className="stat-label">Businesses Onboarded</p>
                </div>
                <div className="stat-item">
                  <h3 className="stat-number">1.5K+</h3>
                  <p className="stat-label">Devices Connected</p>
                </div>
                <div className="stat-item">
                  <h3 className="stat-number">$3M+</h3>
                  <p className="stat-label">Savings for Customers</p>
                </div>
              </div>
            </div>
          </div>

          {/* -------- Benefits -------- */}
          <div className="col-lg-7">
            <div className="about-text-wrapper mb-30">
              <h2 className="sect-title">Why Move Your CRM SMS to TextLink?</h2>

              {/* Simplicity & Price */}
              <div className="benefit-card">
                <div className="benefit-icon">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div className="benefit-content">
                  <h3>Simple & Cost-Effective</h3>
                  <p className="paragraph-title" style={{ color: 'black' }}>
                    Send account-related SMS from your own SIMs at a fraction of aggregator pricing.
                    Setup takes less than an hour and scales from one-off reminders to bulk
                    statements.
                  </p>
                </div>
              </div>

              {/* Setup Assistance */}
              <div className="benefit-card">
                <div className="benefit-icon">
                  <i className="fas fa-headset"></i>
                </div>
                <div className="benefit-content">
                  <h3>Free Concierge Setup</h3>
                  <p className="paragraph-title" style={{ color: 'black' }}>
                    During our launch window we’ll pair your team with a TextLink engineer—whether
                    you need help wiring SIM gateways or configuring your CRM triggers.
                  </p>
                </div>
              </div>

              {/* Scalability */}
              <div className="benefit-card">
                <div className="benefit-icon">
                  <i className="fas fa-rocket"></i>
                </div>
                <div className="benefit-content">
                  <h3>Device-Based Scale</h3>
                  <p className="paragraph-title" style={{ color: 'black' }}>
                    Add phones, not fees. Just drop in extra devices when volume grows—perfect for
                    multi-brand or multi-location CRMs.
                  </p>
                </div>
              </div>

              {/* API */}
              <div className="benefit-card">
                <div className="benefit-icon">
                  <i className="fas fa-code"></i>
                </div>
                <div className="benefit-content">
                  <h3>Developer API</h3>
                  <p className="paragraph-title" style={{ color: 'black' }}>
                    Trigger messages, sync replies, and pull delivery logs from any backend with our
                    fully documented REST API—no marketing endpoints, just clean CRM messaging.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}